/** Formats current catalog prices explicitly as Australian dollars. */
export function formatAudPrice(value: number): string {
  const amount = Number.isFinite(value) ? value : 0;
  return `AUD ${amount.toFixed(2)}`;
}
